import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterParams, SortConfig, SortDirection } from "types/common";
import { PATIENTS_LIMIT } from "constants/dashboard";
import { Joint } from "types/Region";
import { PatientRegion } from "types/PatientRegion";

export interface PatientsState {
  patientRegionsList: PatientRegion[];
  sortConfig: SortConfig;
  joints: Joint[];
  jointFilterParams: FilterParams[];
  limit: number;
  offset: number;
  total: number;
  loading: boolean;
}

const initialState: PatientsState = {
  patientRegionsList: [],
  sortConfig: { sortBy: "lastExam", sortDirection: SortDirection.desc },
  limit: 50,
  offset: 0,
  total: 0,
  joints: [],
  jointFilterParams: [],
  loading: false,
};

export const patientRegionsSlice = createSlice({
  name: "PatientRegions",
  initialState,
  reducers: {
    setPatientRegions: (state, { payload }: PayloadAction<PatientRegion[]>) => {
      state.patientRegionsList = payload;
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setSortConfig: (state, { payload }: PayloadAction<SortConfig>) => {
      state.sortConfig = payload;
    },
    setOffset: (state, { payload }: PayloadAction<number>) => {
      state.offset = payload;
    },
    setJoints: (state, { payload }: PayloadAction<Joint[]>) => {
      state.joints = payload;
    },
    setTotal: (state, { payload }: PayloadAction<number>) => {
      state.total = payload;
    },
    removeCurrentPatientRegion: (state) => {
      state.patientRegionsList = [];
    },
    setJointFilterParams: (
      state,
      { payload }: PayloadAction<FilterParams[]>
    ) => {
      state.jointFilterParams = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setPatientRegions,
  setLoading,
  setSortConfig,
  setOffset,
  setTotal,
  setJoints,
  setJointFilterParams,
  removeCurrentPatientRegion
} = patientRegionsSlice.actions;
export const { reducer } = patientRegionsSlice;
